import React, { Component } from 'react';

class RecordLabels extends Component {
    render() {
        return (
            <div className="record-labels">
              <div className="record-labels-subheader">
                Record Labels
              </div>
              {this.props.labels.length == 0 ? 'No labels found...' : ''}
              {this.props.labels.map((label) =>
              <RecordLabel label={label} onClick={() => this.props.onClickLabel(label.id)}> </RecordLabel>)} 
            </div>
        );
    }
}

class RecordLabel extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div onClick={this.props.onClick} className="youtube-result discogs-result">
              <div className="floating-thumbnail">
                <img className="youtube-result-thumbnail" src={this.props.label.thumbnail}/>
              </div>
              <div className="youtube-result-title">{this.props.label.name}</div>
            </div>);
    }
}


export default RecordLabels;
